import {Injectable} from "@angular/core";
import {Melding, MeldingTilBruker as MeldingTilBrukerAjs, Varighet, VedKlikk} from "../../felles/tjenester/MeldingTilBruker";
import {I18nTekst, Oversettelser} from "./i18n/Oversettelser";

/** Tjeneste for visning av meldinger til bruker.
 * Viser meldinger på 'toast'-liknende form (melding dukker opp i nedre del av vindu).
 *
 * Delegerer til ajs versjonen av MeldingTilBruker
 */
@Injectable({providedIn: 'root'})
export class MeldingTilBrukerNg2 {

    constructor(private ajsMeldinger: MeldingTilBrukerAjs, private oversettelser: Oversettelser) {
    }

    /**
     * Viser infomelding til bruker.
     *
     * Dersom det allerede er reg en melding med samme tekst registreres det IKKE noen ny melding.
     *
     * @param melding {@link I18nTekst} instans eller lokalisert streng med melding som skal vises, melding kan ikke inneholde HTML-formatering
     * @param  varighet  hvor lenge meldingen skal vises
     * @param  vedKlikk  callback som kalles dersom bruker klikker på melding, meldingen skjules dersom callback returnerer sann
     */
    infomelding(melding: string | I18nTekst, varighet: Varighet = Varighet.timeout, vedKlikk: VedKlikk = null): Melding {
        if (melding instanceof I18nTekst) melding = melding.oversett(this.oversettelser);
        return this.ajsMeldinger.infomelding(melding, varighet, vedKlikk);
    }

    /**
     * Viser advarselmelding til bruker.
     *
     * Dersom det allerede er reg en melding med samme tekst registreres det IKKE noen ny melding.
     *
     * @param melding {@link I18nTekst} instans eller lokalisert streng med melding som skal vises, melding kan ikke inneholde HTML-formatering
     * @param  varighet  hvor lenge meldingen skal vises
     * @param  vedKlikk  callback som kalles dersom bruker klikker på melding, meldingen skjules dersom callback returnerer sann
     */
    advarselmelding(melding: string | I18nTekst, varighet: Varighet = Varighet.timeout, vedKlikk: VedKlikk = null): Melding {
        if (melding instanceof I18nTekst) melding = melding.oversett(this.oversettelser);
        return this.ajsMeldinger.advarselmelding(melding, varighet, vedKlikk);
    }

    /**
     * Viser feilmelding til bruker.
     *
     * Dersom det allerede er reg en melding med samme tekst registreres det IKKE noen ny melding.
     *
     * @param melding {@link I18nTekst} instans eller lokalisert streng med melding som skal vises, melding kan ikke inneholde HTML-formatering
     * @param  varighet  hvor lenge meldingen skal vises
     * @param  vedKlikk  callback som kalles dersom bruker klikker på melding, meldingen skjules dersom callback returnerer sann
     */
    feilmelding(melding: string | I18nTekst, varighet: Varighet = Varighet.timeout, vedKlikk: VedKlikk = null, skrivTilLog = true): Melding {
        if (melding instanceof I18nTekst) melding = melding.oversett(this.oversettelser);
        return this.ajsMeldinger.feilmelding(melding, varighet, vedKlikk, skrivTilLog);
    }
}
